<template>
  <div class="body-panel dataContent">
    <div
      class="body-panel-control separator"
      v-if="info.User && info.ProjectsLength > 1"
    >
      <div class="control-block-left">
        <project-select
          :user="info.User"
          @onChange="onProjectChange"
        ></project-select>
      </div>
    </div>

    <div class="body-panel-content body-panel-content-page">
      <div v-if="info.SelectedProject.Id === currentProjectIds.Daccord">
        <daccord-banner :balance="currentBalance" />
      </div>
    </div>

    <vue-headful :title="getPageTitle()" />
  </div>
</template>

<script>
import projectMixin from "../helpers/project-mixin";
import UI from "../helpers/ui-helpers";
import DaccordBanner from "../components/MyProgress/Daccord/DaccordBanner.vue";
import { ProjectIds } from "../enums";
import config from "../config";

export default {
  name: "my-progress",

  props: ["info"],

  mixins: [projectMixin],

  components: {
    DaccordBanner,
  },

  data() {
    return {
      isMobile: UI.check_mobile(),
      currentProjectIds: ProjectIds[config.mode],
    };
  },

  computed: {
    currentBalance() {
      return this.info && this.info.User && this.info.User.PotentialBalance
        ? this.info.User.PotentialBalance
        : 0;
    },
  },

  methods: {
    onProjectChange(item) {
      this.$emit("user-updated");
    },
  },
};
</script>

<style scoped>
.table-view thead {
  display: table-header-group;
}
</style>



// WEBPACK FOOTER //
// Content/src/views/MyProgress.vue